import React from 'react';
import { Badge, Text } from '@fluentui/react-components';

type ConfidenceLevel = 'high' | 'medium' | 'low';

export interface ConfidenceMeta {
  score: number;
  reasons?: readonly string[];
}

function clampScore(score: number): number {
  if (!Number.isFinite(score)) return 0;
  return Math.max(0, Math.min(100, Math.round(score)));
}

function getLevel(score: number): ConfidenceLevel {
  if (score >= 80) return 'high';
  if (score >= 55) return 'medium';
  return 'low';
}

function levelBadge(level: ConfidenceLevel): {
  label: string;
  color: 'success' | 'warning' | 'danger';
} {
  if (level === 'high') return { label: 'Fiabilite elevee', color: 'success' };
  if (level === 'medium') return { label: 'Fiabilite moyenne', color: 'warning' };
  return { label: 'Verification recommandee', color: 'danger' };
}

interface ConfidenceBadgeProps {
  readonly title?: string;
  readonly meta: ConfidenceMeta;
}

export const ConfidenceBadge: React.FC<ConfidenceBadgeProps> = ({
  title = 'Confiance estimee',
  meta,
}) => {
  const score = clampScore(meta.score);
  const level = getLevel(score);
  const badge = levelBadge(level);

  return (
    <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <Text size={200} style={{ color: 'var(--text-secondary)' }}>
          {title}: <strong>{score}%</strong>
        </Text>
        <Badge size="small" color={badge.color}>
          {badge.label}
        </Badge>
      </div>
      {meta.reasons && meta.reasons.length > 0 && (
        <Text size={100} style={{ color: 'var(--text-secondary)' }}>
          {meta.reasons.slice(0, 2).join(' ')}
        </Text>
      )}
    </div>
  );
};
